const INTERNAL_GRID_ROW_ID = 'internal_grid_row_id';
const INTERNAL_GRID_VALUE_SET = '__internal_value_set__';

export { INTERNAL_GRID_ROW_ID, INTERNAL_GRID_VALUE_SET };
